import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core"
import { Button } from "components"
import { StatusActions } from "types";

const DraftStatusActions = ({ onClick, isLoading }: StatusActions) => {
  const { t } = useTranslation();

  return (
    <>
      <Box ml={'sm'}>
        <Button size={'compact-md'} onClick={() => onClick('PROCESSING')} loading={isLoading}>
          {t('credit.status.action.PROCESSING')}
        </Button>
      </Box>
      <Box ml={'sm'}>
        <Button size={'compact-md'} variant={'outline'} color={'var(--mantine-color-error)'} onClick={() => onClick('CANCELED')} loading={isLoading}>
          {t('credit.status.action.CANCELED')}
        </Button>
      </Box>
    </>
  )
}

export default DraftStatusActions;